module.exports = __webpack_public_path__ + "static/media/analyse.28e860e2.mp4";